import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';
import { isResourceType } from '@backstage/plugin-catalog';

/**
 * Les ressources `resource:database` (une par environnement, ex. `<système>-db-prod`,
 * `<système>-db-preprod`) avaient une page dédiée dans `EntityPage.tsx`
 * (phase 4b, tâche 7) : trois onglets — Overview (`DatabaseOverview`), « Base
 * de données » (`DatabasePanel`), « Sauvegardes » (`BackupsPage`, plugin
 * séparé `@platform/plugin-db-backup`).
 *
 * `DatabaseOverview` devient une carte de la vue d'ensemble partagée
 * (`entity-card:database/overview`, même mécanique que `ServiceStatusCard`
 * côté `service-status`) : l'onglet « Vue d'ensemble » n'appartient à
 * personne en particulier, chaque domaine y dépose sa carte. `DatabasePanel`
 * garde son propre onglet, à `/db`.
 *
 * Ni Kubernetes ni Docs ici : `genericResourcePage` les porte pour les
 * ressources annotées, mais une ressource `database` n'a ni l'un ni l'autre
 * d'utile — elle n'en avait déjà pas avant l'extraction.
 */
const isDatabase = isResourceType('database');

const databaseOverviewCard = EntityCardBlueprint.make({
  name: 'overview',
  params: {
    type: 'content',
    filter: isDatabase,
    loader: () =>
      import('./DatabaseOverview').then(m => <m.DatabaseOverview />),
  },
});

const databasePanelContent = EntityContentBlueprint.make({
  name: 'db',
  params: {
    path: '/db',
    title: 'Base de données',
    filter: isDatabase,
    loader: () => import('./DatabasePanel').then(m => <m.DatabasePanel />),
  },
});

export default createFrontendPlugin({
  pluginId: 'database',
  extensions: [databaseOverviewCard, databasePanelContent],
});
